// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"

import {disableWebshopSource} from "../../actions/baby"

type Props = {
  +t: any,
  +babyToken: string,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
}

type State = {}

class DisableWebshopSourceModal extends React.Component<Props, State> {
  handleDisableWebshopSource: () => void

  constructor(props: Props) {
    super(props)

    this.handleDisableWebshopSource = this.handleDisableWebshopSource.bind(this)
  }

  handleDisableWebshopSource() {
    const {dispatch, babyToken, handleCloseModal} = this.props
    if (!window.confirm("Zeker?")) return
    dispatch(disableWebshopSource(babyToken))
    handleCloseModal()
  }

  render() {
    const {t} = this.props
    return (
      <Modal
        className="modal-dialog"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel=""
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Disable `intake_not_invoiced`</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("intake.sendOffer.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <p>
              We zien dat er nog te factureren webshop producten actief staan op
              de intake, naast het gebundelde &quot;Producten eigen
              webshop&quot;. Mogen deze gedeactiveerd worden voor facturatie?
            </p>
            <button
              className="btn btn-warning"
              onClick={this.handleDisableWebshopSource}
            >
              Deactiveer
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connect()(DisableWebshopSourceModal))
